export default "__VITE_ASSET____7OW72g__"